import $ from "jquery";
import Notices from "./Notices";

export default class CustomLogos {
    constructor() {
        this.init();
        this.events();
    }

    init() {
        this.removeLogoBtns = document.querySelectorAll(".jsRemoveLogo");
        this.addLogoBtn = document.querySelector(".jsAddLogo");
        this.container = document.querySelector(
            ".woocommerce-MyAccount-content"
        );
        this.customLogoBody = document.querySelector(".jsLogoBody");
        this.privateLabelForm = document.querySelector(".jsPrivateLabelForm");
        this.myAccountLogos = $(".jsMyAccountLogos");
        this.customLogoWrapper = document.querySelector(".jsCustomLogoWrapper");
        this.customLogoPopup = document.querySelector(".jsCustomLogoPopup");
        this.expandSubOptionsFirst = document.querySelector(
            ".jsExpandSubOptionsFirst"
        );
        this.expandSubOptionsLast = document.querySelector(
            ".jsExpandSubOptionsLast"
        );

        this.filesToSend = "";
    }

    events() {
        if (this.removeLogoBtns) {
            this.removeLogoBtns.forEach((removeLogoBtn) =>
                removeLogoBtn.addEventListener("click", (e) =>
                    this.removeLogo(e)
                )
            );
        }

        if (this.addLogoBtn) {
            this.addLogoBtn.addEventListener("click", this.addLogo.bind(this));
        }

        if (this.addLogoForm) {
            this.addLogoForm.addEventListener("submit", (e) => {
                e.preventDefault();
                this.saveNewLogo();
            });
        }

        if (this.privateLabelForm) {
            this.privateLabelForm.addEventListener("submit", (e) => {
                e.preventDefault();
                this.loadOrderView();
            });
        }

        if (this.popupModalClose) {
            this.popupModalClose.addEventListener("click", () => {
                this.customLogoWrapper.classList.remove("is-active");
            });
        }

        if (this.popupModalLayer) {
            this.popupModalLayer.addEventListener("click", () => {
                this.customLogoWrapper.classList.remove("is-active");
            });
        }

        if (this.placeOrderForm) {
            this.placeOrderForm.addEventListener("submit", (e) => {
                e.preventDefault();
                this.placeOrder();
            });
        }

        if (this.expandSubOptionsFirst) {
            this.expandSubOptionsFirst.addEventListener("click", (e) => {
                this.expandSubOptionsFirst
                    .closest(".single-product__custom-logo-group")
                    .querySelector(".single-product__custom-logo-sub-options")
                    .classList.toggle("is-active");

                if (
                    this.expandSubOptionsLast
                        .closest(".single-product__custom-logo-group")
                        .querySelector(
                            ".single-product__custom-logo-sub-options"
                        )
                        .classList.contains("is-active") === true
                ) {
                    this.expandSubOptionsLast
                        .closest(".single-product__custom-logo-group")
                        .querySelector(
                            ".single-product__custom-logo-sub-options"
                        )
                        .classList.remove("is-active");

                    this.expandSubOptionsLast.checked = false;
                }
            });
        }

        if (this.expandSubOptionsLast) {
            this.expandSubOptionsLast.addEventListener("click", (e) => {
                this.expandSubOptionsLast
                    .closest(".single-product__custom-logo-group")
                    .querySelector(".single-product__custom-logo-sub-options")
                    .classList.toggle("is-active");

                if (
                    this.expandSubOptionsFirst
                        .closest(".single-product__custom-logo-group")
                        .querySelector(
                            ".single-product__custom-logo-sub-options"
                        )
                        .classList.contains("is-active") === true
                ) {
                    this.expandSubOptionsFirst
                        .closest(".single-product__custom-logo-group")
                        .querySelector(
                            ".single-product__custom-logo-sub-options"
                        )
                        .classList.remove("is-active");

                    this.expandSubOptionsFirst.checked = false;
                }
            });
        }
    }

    removeLogo(event) {
        this.myAccountLogos.block({
            message: null,
            overlayCSS: {
                cursor: "none",
                background: "#fff",
                opacity: 0.6,
            },
        });

        fetch(window.global.ajax_url + "?action=RemoveLogo", {
            method: "POST", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
                security: window.global.security,
                row: event.target.dataset.rowIndex,
            }),
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
        })
            .then((resp) => resp.json())
            .then((data) => {
                this.getRefreshedFragments();
            })
            .catch((err) => {
                console.log(err);
            });
    }

    addLogo() {
        this.myAccountLogos.block({
            message: null,
            overlayCSS: {
                cursor: "none",
                background: "#fff",
                opacity: 0.6,
            },
        });

        fetch(window.global.ajax_url + "?action=AddLogo", {
            method: "GET", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
        })
            .then((resp) => resp.json())
            .then((data) => {
                this.customLogoBody.innerHTML += data.data;
                document
                    .querySelector(".my-account__logos__wrap")
                    .setAttribute("aria-hidden", false);
                document
                    .querySelector(".my-account__logos__empty")
                    .setAttribute("aria-hidden", true);
                this.addLogoBtn.disabled = true;
                $(".blockUI").remove();
                this.addLogoForm = document.querySelector(".jsAddLogoForm");
                this.events();
            })
            .catch((err) => {
                console.log(err);
            });
    }

    saveNewLogo() {
        const formData = new FormData(this.addLogoForm);
        formData.append("security", window.global.security);

        this.myAccountLogos.block({
            message: null,
            overlayCSS: {
                cursor: "none",
                background: "#fff",
                opacity: 0.6,
            },
        });

        fetch(window.global.ajax_url + "?action=SaveNewLogo", {
            method: "POST", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            body: formData,
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
        })
            .then((resp) => resp.json())
            .then((data) => {
                this.getRefreshedFragments();
                this.addLogoBtn.disabled = false;

                // eslint-disable-next-line no-unused-vars
                const cartNotices = new Notices(true);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    getRefreshedFragments() {
        fetch(window.global.ajax_url + "?action=GetRefreshedFragments", {
            method: "GET", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
        })
            .then((resp) => resp.json())
            .then((data) => {
                this.container.innerHTML = data.data;
                $(".blockUI").remove();
                this.init();
                this.events();
            })
            .catch((err) => {
                console.log(err);
            });
    }

    loadOrderView() {
        this.customLogoWrapper.classList.add("is-active");
        $(".jsCustomLogoPopup").block({
            message: null,
            overlayCSS: {
                cursor: "none",
                background: "#fff",
                opacity: 0.6,
            },
        });

        const formData = new FormData(this.privateLabelForm);

        fetch(window.global.ajax_url + "?action=LoadOrderView", {
            method: "POST", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            body: formData,
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
        })
            .then((resp) => resp.json())
            .then((data) => {
                this.customLogoPopup.innerHTML = data.data.html;
                this.popupModalLayer = document.querySelector(
                    ".jsCustomLogoWrapper .custom-logo__layer"
                );
                this.popupModalClose = document.querySelector(
                    ".jsCustomLogoWrapper .custom-logo__close"
                );
                this.placeOrderForm = document.querySelector(
                    ".jsCustomLogoPlaceOrder"
                );
                this.events();
                $(".blockUI").remove();
            })
            .catch((err) => {
                console.log(err);
            });
    }

    placeOrder() {
        const formData = new FormData(this.placeOrderForm);

        $(".jsCustomLogoPopup").block({
            message: null,
            overlayCSS: {
                cursor: "none",
                background: "#fff",
                opacity: 0.6,
            },
        });

        fetch(window.global.ajax_url + "?action=PlaceOrderCustomLogo", {
            method: "POST", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            body: formData,
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
        })
            .then((resp) => resp.json())
            .then((data) => {
                this.customLogoPopup.innerHTML = data.data;
                this.events();
                $(".blockUI").remove();
            })
            .catch((err) => {
                console.log(err);
            });
    }
}
